import { render, staticRenderFns } from "./EditGoods.vue?vue&type=template&id=4dd6dc56&scoped=true"
import script from "./EditGoods.vue?vue&type=script&lang=js"
export * from "./EditGoods.vue?vue&type=script&lang=js"
import style0 from "./EditGoods.vue?vue&type=style&index=0&id=4dd6dc56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6dc56",
  null
  
)

export default component.exports